export const ZEALOT_TOKEN_ISSUER = 'zealot-backend';
export const ZEALOT_TOKEN_AUDIENCE = 'zealot-api';
